const icons = {
  // Level 01
  pencil: <i className='fa-solid fa-pencil'></i>,
  eraser: <i className='fa-solid fa-eraser'></i>,
  swatchbook: <i className='fa-solid fa-swatchbook'></i>,
  compass: <i className='fa-solid fa-compass-drafting'></i>,
  // Level 02
  laptop: <i className='fa-solid fa-laptop'></i>,
  picture: <i className='fa-solid fa-image'></i>,
  trophy: <i className='fa-solid fa-trophy'></i>,
  plant: <i className='fa-solid fa-seedling'></i>,
  // Level 03 && 04
  ticket: <i className='fa-solid fa-ticket'></i>,
  mobile: <i className='fas fa-mobile-alt'></i>,
  headphones: <i className='fa-solid fa-headphones'></i>,
  key: <i className='fas fa-key'></i>,
  // Level 05
  cheese: <i className='fa-solid fa-cheese'></i>,
  bread: <i className='fa-solid fa-bread-slice'></i>,
  biscuit: <i className='fa-solid fa-cookie'></i>,
  apple: <i className='fa-solid fa-apple-whole'></i>,
  carrot: <i className='fa-solid fa-carrot'></i>,
  // Level 06
  lemon: <i className='fa-solid fa-lemon'></i>,
  ice: <i className='fa-solid fa-cubes-stacked'></i>,
  cream: <i className='fa-solid fa-jar'></i>,
  'lemon ice cream': <i className='fa-solid fa-ice-cream'></i>
}

export default icons;
